var image_viewer_rtlignore_default = {
  "fontElementMap": "_7rdxq",
  "imageFigure": "ZWIk2",
  "imageContainer": "nmc2U",
  "expandContainer": "rqJDX",
  "expandIcon": "tl9Lh",
  "pointer": "yvGIY",
  "imageWrapper": "LLSuS",
  "imageRatio": "MkfQY",
  "image": "b9S62",
  "imageOverlay": "jHL0T",
  "imagePreload": "_8H0SL",
  "imageHighres": "B9PhP",
  "onlyHighRes": "_9rS-C",
  "image_loading": "lGVmq"
};
export {
  image_viewer_rtlignore_default as default
};
//# sourceMappingURL=image-viewer.rtlignore-scss.js.map
